import React from 'react';
import { Form, Input, Button, Card, message } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import '../styles/Login.css';

const Login = () => {
  const navigate = useNavigate();

  const onFinish = (values) => {
    // 在实际项目中，这里应该调用API进行登录验证
    // 这里仅作演示用途简单处理
    if (values.username === 'admin' && values.password === 'admin123') {
      localStorage.setItem('user', JSON.stringify({
        username: values.username,
        role: 'admin',
      }));
      message.success('登录成功！');
      navigate('/');
    } else {
      message.error('用户名或密码错误！');
    }
  };

  return (
    <div className="login-container">
      <div className="login-content">
        <Card className="login-card">
          <div className="login-title">AI视频监控平台</div>
          <Form
            name="login"
            className="login-form"
            initialValues={{ remember: true }}
            onFinish={onFinish}
          >
            <Form.Item
              name="username"
              rules={[{ required: true, message: '请输入用户名！' }]}
            >
              <Input 
                prefix={<UserOutlined className="site-form-item-icon" />} 
                placeholder="用户名（admin）" 
                size="large"
              />
            </Form.Item>
            <Form.Item
              name="password"
              rules={[{ required: true, message: '请输入密码！' }]}
            >
              <Input
                prefix={<LockOutlined className="site-form-item-icon" />}
                type="password"
                placeholder="密码（admin123）"
                size="large"
              />
            </Form.Item>

            <Form.Item>
              <Button type="primary" htmlType="submit" className="login-form-button" size="large">
                登录
              </Button>
            </Form.Item>
          </Form>
          <div className="login-footer">版本: 1.26</div>
        </Card>
      </div>
    </div>
  );
};

export default Login;
